import { gl } from '../../Engine';
import { Environment } from '../../data/Environment';
import { StructureSetObject } from '../../data/structure/StructureSetObject';
import { TextureView } from '../TextureView';
import { Layer } from './Layer';
import { LayerBit } from './LayerBit';
import { ContourFilter, FilterClass } from './filters/Filter';

/**
 * {@link ContourLayer} provides common properties of {@link Layer Layers} for {@link StructureSetObject Contour}data.\
 * {@link ContourLayer ContourLayers} have {@link internalFormat} of type {@link gl.RGBA8} and\
 * {@link format} of type {@link gl.RGBA}.
 */
export class ContourLayer extends Layer<StructureSetObject> {
    /**
     * {@link ContourLayer} constructor which constructs a new {@link ContourLayer} with the {@link getDefaultFilter default contour filter}.
     * @param parent {@link TextureView} on which this {@link ContourLayer} resides.
     */
    public constructor(parent: TextureView, env: Environment) {
        super(parent, env);
    }

    /**
     * Method to get the default {@link FilterClass} used by {@link ContourLayer ContourLayers}.
     * @returns The {@link ContourFilter}, which renders the {@link StructureSetObject contour data} without any {@link ContourFilter.postProcessing postprocessing effects}.
     */
    public getDefaultFilter(): FilterClass<StructureSetObject> {
        return ContourFilter;
    }

    /**
     * The internal format of {@link ContourLayer}s' {@link Layer._texture texture}.\
     * {@link ContourLayer ContourLayers} use this format to support colors.\
     * The number of {@link TextureView Views} & {@link Layer Layers} is so small
     * that the memory difference between 8bit and 32bit view textures does not make much difference.
     */
    public get internalFormat(): number {
        return gl.RGBA8;
    }

    /**
     * The format of the {@link Layer._texture texture} this {@link Layer} defines.
     */
    public get format(): number {
        return gl.RGBA;
    }

    /**
     * The {@link LayerBit.CONTOUR_LAYER_BIT}
     */
    public get layerBit(): number {
        return LayerBit.CONTOUR_LAYER_BIT;
    }

    /**
     * Method to retrieve the {@link StructureSetObject StructureSetObjects} currently loaded in the {@link Environment}.
     * @param environment The {@link Environment} from which the {@link StructureSetObject StructureSetObjects} are loaded.
     * @returns An {@link Array} of all the {@link StructureSetObject StructureSetObjects} currently loaded in the {@link environment}.
     */
    public getTargets(environment: Environment): StructureSetObject[] {
        if (environment.structureSet) {
            return [environment.structureSet];
        }
        return [];
    }
}
